
const networkData1 = {
  networkid: 1,
  rpc: "https://rpc.soniclabs.com",
  chainId: 146,
  hex: "0x92",
  theme: "darkorange",
  coin: 'S',
  brainaddress: '0x6F92182a22D76177C98589D65275Bb104C81C4e5', 
  brainNFTaddress: '0xC182ff2A7bB6360951087E8353f200e2Fccb298A', 
  bridgeaddress: "",
  ecosystem: "Sonic"
};

const networkData2 = {
  networkid: 2,
  rpc: "https://bsc-rpc.publicnode.com",
  chainId: 56,
  hex: "0x38",
  theme: "gold",
  coin: 'BNB',
  brainaddress: "0x06cf46F985518085a5dB2b2bf9C06f0906265B33",
  brainNFTaddress: "0x5A38C45ADF4c43399c14221868C93A6Fd8a8b8bA",
  bridgeaddress: "",
  ecosystem: "BSC"
};  



const networkData3 = {
  networkid: 3,
  rpc: "https://mainnet.base.org",
  chainId: 8453,
  hex: "0x2105",
  theme: "dodgerblue",
  coin: 'ETH',
  brainaddress: "0x305E970E5E2620aD91DbCAD299cB91840E70bef5",
  brainNFTaddress: "0x87c18AA321ad9443120887ef8Ce781F991B127d2",
  bridgeaddress: "",
  ecosystem: "Base"
  };
    
  const networkData4 = {
    networkid: 4,
    rpc: "https://rpc.ankr.com/polygon",
    chainId: 137,
    hex: "0x89",
    theme: "purple",
    coin: 'POL',
    brainaddress: "0x06cf46F985518085a5dB2b2bf9C06f0906265B33",
    brainNFTaddress: "0x34377c405Be72127e3AF43f414526572f7Af3485",
    bridgeaddress: "",
    ecosystem: "Polygon"
  };  


export const networkDataArray = [
  networkData1, networkData2, networkData3, networkData4
]
